/* Page D: book a call (6 Oct 2026). No dependencies.
   The booking card talks to the same public booking API as /pages/book-a-call (flow.vervefitness.ai, Niall's system):
     GET  <api>/slots?from=YYYY-MM-DD&to=YYYY-MM-DD&duration=15|30   -> { duration, slots: [ISO start, ...] }
     POST <api>/book { start, duration, name, email, phone, company, topic, channel, tz, turnstile_token, idempotency_key }
          -> 200 { ok, booking: { start, duration, rep_name, channel, teams_join_url, manage_token } } | 409 taken | 403 check failed
   15-minute calls went live on the API on 6 Oct 2026 (Niall). The page always sends the length the visitor picked.
   Every booking (and every call-back request) also goes to HubSpot, like the other B2B pages, with the buyer type,
   lease, postcode, offer version and the time booked in the message.
   The Shopify build sets data-api, data-turnstile and data-hubspot on [data-booking]. Without data-api (the concept file)
   the calendar shows demo times and nothing is sent anywhere. */
(function () {
  'use strict';
  var root = document.querySelector('[data-booking]');
  if (!root) return;

  var params = (function () { try { return new URLSearchParams(location.search); } catch (e) { return { get: function () { return null; } }; } })();
  var OFFER = /^call$/i.test(params.get('offer') || '') ? 'call' : 'design';
  document.documentElement.classList.toggle('offer-call', OFFER === 'call');
  var OFFER_NAME = { design: 'Free 3D gym design', call: 'Talk to a fit-out specialist' };

  var API = root.getAttribute('data-api') || '';
  var SITEKEY = root.getAttribute('data-turnstile') || '';
  var HS = root.getAttribute('data-hubspot') || '';
  var REP = (params.get('rep') || '').trim();

  /* Cancel links (booking emails and the booked panel) open /pages/book-a-call?manage=<token>. Niall's booking system owns
     cancelling, so on such a link the card hands over to his own widget, which reads the token from the address. */
  var MANAGE = (params.get('manage') || '').trim();
  if (MANAGE) {
    root.setAttribute('data-step', 'manage');
    var head = root.querySelector('.bk__head b'); if (head) head.textContent = 'YOUR BOOKING';
    var body = root.querySelector('.bk__body');
    body.innerHTML = '<div id="verve-booking"></div>';
    if (API) {
      var w = document.createElement('script');
      w.src = API + '/widget';
      w.defer = true;
      document.body.appendChild(w);
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'verve_booking_manage_open', offer: OFFER, page_type: 'book-a-call' });
    return;
  }
  // Booking window (Brandon, 6 Oct 2026): the rest of this calendar week plus all of next week (weeks run Monday to Sunday).
  // The booking system itself opens about 3 weeks ahead; the page shows less.
  function windowEnd(today) { var p = parts(today), mon = (new Date(Date.UTC(p.y, p.m, p.d)).getUTCDay() + 6) % 7; return addDays(today, 6 - mon + 7); }
  var TEXT_LINE = '0468 003 121';

  var TZ = (function () {
    var z = 'Australia/Brisbane';
    try { z = Intl.DateTimeFormat().resolvedOptions().timeZone || z; new Date().toLocaleString('en-AU', { timeZone: z }); } catch (e) { z = 'Australia/Brisbane'; }
    return z;
  })();
  var TZ_LABEL = TZ.split('/').pop().replace(/_/g, ' ') + ' time';

  function q(s) { return root.querySelector(s); }
  var el = {
    grid: q('.bk__grid'), month: q('.bk__month'), prev: q('[data-month="-1"]'), next: q('[data-month="1"]'), status: q('.bk__status'),
    slots: q('.bk__slots'), dayname: q('.bk__dayname'), flash: q('.bk__flash'), tz: q('.bk__tz'), form: q('#bk-form'), err: q('#bk-form .fx__err'),
    when: q('.bk__when'), whensub: q('.bk__whensub'), change: q('.bk__change'), done: q('.bk__done'), go: q('.bk__go'),
    lease: q('[data-lease]'), channel: q('[data-channel]')
  };
  var lenBox = q('[data-len]');
  var state = { byDay: {}, days: [], month: null, minMonth: null, maxMonth: null, day: null, slot: null, mode: 'book', busy: false, rep: null,
    duration: +((lenBox && lenBox.querySelector('input:checked')) || { value: 30 }).value }; // the default length is the tile marked checked in the HTML
  var cache = {}; // open times per call length, so switching 15 / 30 is instant
  var swappedAt = 0; // the times appear where the days were: a double tap must not also pick a time

  /* ---------- helpers ---------- */
  function track(name, data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: 'verve_' + name, offer: OFFER, page_type: 'book-a-call' }, data || {}));
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function dayKey(iso) { return new Date(iso).toLocaleDateString('en-CA', { timeZone: TZ }); } // YYYY-MM-DD in the visitor's zone
  function todayKey() { return new Date().toLocaleDateString('en-CA', { timeZone: TZ }); }
  function parts(k) { var p = k.split('-'); return { y: +p[0], m: +p[1] - 1, d: +p[2] }; }
  function keyOf(y, m, d) { var t = new Date(Date.UTC(y, m, d)); return t.getUTCFullYear() + '-' + pad(t.getUTCMonth() + 1) + '-' + pad(t.getUTCDate()); }
  function addDays(k, n) { var p = parts(k); return keyOf(p.y, p.m, p.d + n); }
  function fmtDay(k, opts) { var p = parts(k); return new Date(Date.UTC(p.y, p.m, p.d, 12)).toLocaleDateString('en-AU', Object.assign({ timeZone: 'UTC' }, opts)); }
  function fmtTime(iso) { return new Date(iso).toLocaleTimeString('en-AU', { timeZone: TZ, hour: 'numeric', minute: '2-digit', hour12: true }).replace(/\s/g, '').toLowerCase(); }
  function longWhen(iso) { return fmtDay(dayKey(iso), { weekday: 'long', day: 'numeric', month: 'long' }) + ' at ' + fmtTime(iso); }
  function monthIndex(o) { return o.y * 12 + o.m; }
  function wide() { return root.clientWidth >= 600; } // matches the @container rule in d.css
  function leadId() {
    try { if (window.crypto && crypto.randomUUID) return crypto.randomUUID(); } catch (e) {}
    return 'vl-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }
  function idemKey(slot) {
    var k = 'vb_idem_' + slot, v = null;
    try { v = sessionStorage.getItem(k); if (!v) { v = leadId(); sessionStorage.setItem(k, v); } } catch (e) { v = leadId(); }
    return v;
  }
  function cookie(n) { var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; }
  function inViewCentre(node) {
    var r = node.getBoundingClientRect();
    window.scrollTo({ top: window.scrollY + r.top - window.innerHeight / 3, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  }
  function inView(node) {
    var r = node.getBoundingClientRect();
    if (r.top < 8 || r.top > window.innerHeight * 0.55) {
      window.scrollTo({ top: window.scrollY + r.top - 12, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
  }

  /* ---------- steps ---------- */
  function setStep(s) {
    if (s !== root.getAttribute('data-step')) el.flash.hidden = true; // a message belongs to the step it was shown on
    root.setAttribute('data-step', s);
    el.form.hidden = s !== 'details';
    el.done.hidden = s !== 'done';
  }

  /* ---------- times ---------- */
  function fetchSlots(len) {
    if (cache[len]) return cache[len];
    var from = todayKey(), to = addDays(windowEnd(from), 1); // the API reads dates in UTC, so ask one day more and trim in applySlots
    cache[len] = (API
      ? fetch(API + '/slots?from=' + from + '&to=' + to + '&duration=' + len + (REP ? '&rep=' + encodeURIComponent(REP) : ''), { cache: 'no-store' })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      : demoSlots(len)
    ).catch(function (e) { delete cache[len]; throw e; });
    return cache[len];
  }

  function load(keepDay, fresh) {
    setStep('loading');
    skeleton();
    if (fresh) cache = {}; // after a time was taken, ask again for both lengths
    return fetchSlots(state.duration).then(function (d) {
      applySlots(d, keepDay);
      setStep(keepDay && state.day && !wide() ? 'time' : 'day');
      fetchSlots(state.duration === 15 ? 30 : 15).catch(function () {}); // the other length, ready for a switch
    }).catch(function () {
      el.status.hidden = false;
      el.status.innerHTML = 'We couldn’t load the call times. <button type="button" data-retry>Try again</button>, or call <a href="tel:1300194748" data-call="times-failed">1300 1947 48</a>.';
      el.grid.innerHTML = '';
      el.month.textContent = '';
      el.prev.disabled = el.next.disabled = true;
      setStep('error');
      track('booking_error', { stage: 'slots' });
    });
  }

  function applySlots(d, keepDay, keepEmptyDay) {
      var lastDay = windowEnd(todayKey());
      state.rep = d.rep || null;
      state.byDay = {};
      var soon = Date.now() + 10 * 60 * 1000; // never offer a time that starts in the next ten minutes
      (d.slots || []).forEach(function (iso) {
        if (new Date(iso).getTime() < soon) return;
        var k = dayKey(iso);
        if (k > lastDay) return; // past the booking window in the visitor's own time
        (state.byDay[k] = state.byDay[k] || []).push(iso);
      });
      Object.keys(state.byDay).forEach(function (k) { state.byDay[k].sort(); });
      state.days = Object.keys(state.byDay).sort();
      var t = parts(todayKey());
      var first = state.days.length ? parts(state.days[0]) : t, last = state.days.length ? parts(state.days[state.days.length - 1]) : t;
      state.minMonth = { y: first.y, m: first.m };
      state.maxMonth = { y: last.y, m: last.m };
      state.day = keepDay && (state.byDay[keepDay] || keepEmptyDay) ? keepDay : null;
      if (!state.day && wide() && state.days.length) state.day = state.days[0]; // a wide card shows the first day's times straight away
      state.month = state.day ? { y: parts(state.day).y, m: parts(state.day).m } : { y: state.minMonth.y, m: state.minMonth.m };
      el.tz.textContent = 'Times are in ' + TZ_LABEL + '.';
      if (!state.days.length) {
        el.status.hidden = false;
        el.status.innerHTML = 'No call times are open this week or next. <button type="button" data-callback>Ask us to call you</button> or call <a href="tel:1300194748" data-call="no-times">1300 1947 48</a>.';
        track('booking_error', { stage: 'no_times' });
      } else {
        el.status.hidden = true;
      }
      renderMonth();
      renderTimes();
  }

  function skeleton() {
    var h = '';
    root.classList.add('bk--chips'); for (var i = 0; i < 8; i++) h += '<span class="bk__day bk__day--skel bk__chip" aria-hidden="true"></span>';
    el.grid.innerHTML = h;
    el.prev.disabled = el.next.disabled = true;
  }

  // 27 Oct 2026 (Jacqueline, Clarity dead clicks): show only the days that have open times, as chips. The month grid showed 28 of 31 days greyed out,
  // and every tap on a grey day was a dead click. The booking window is two weeks, so no month paging is needed.
  function renderMonth() {
    var today = todayKey(), h = '';
    root.classList.add('bk--chips');
    state.days.forEach(function (k) {
      var n = (state.byDay[k] || []).length; if (!n) return;
      var label = fmtDay(k, { weekday: 'long', day: 'numeric', month: 'long' }) + ', ' + n + (n === 1 ? ' time' : ' times') + ' open';
      h += '<button type="button" class="bk__day bk__chip' + (k === today ? ' bk__day--today' : '') + '" data-day="' + k + '" data-open aria-pressed="' + (state.day === k) + '" aria-label="' + esc(label) + '">' +
        '<small>' + esc(fmtDay(k, { weekday: 'short' }).toUpperCase()) + '</small><b>' + parts(k).d + '</b><small>' + esc(fmtDay(k, { month: 'short' }).toUpperCase()) + '</small></button>';
    });
    el.grid.innerHTML = h;
    el.month.textContent = '';
    el.prev.disabled = el.next.disabled = true;
  }

  function renderTimes() {
    var k = state.day;
    if (!k) { el.dayname.textContent = 'Pick a day to see the open times.'; el.slots.innerHTML = ''; return; }
    el.dayname.textContent = fmtDay(k, { weekday: 'long', day: 'numeric', month: 'long' });
    var list = state.byDay[k] || [];
    el.slots.innerHTML = list.length
      ? list.map(function (iso) { return '<button type="button" class="bk__slot" data-slot="' + esc(iso) + '">' + fmtTime(iso) + '</button>'; }).join('')
      : '<p class="bk__none">No times left on this day. Pick another day.</p>';
  }

  /* ---------- details ---------- */
  function openDetails(mode) {
    state.mode = mode;
    root.setAttribute('data-mode', mode);
    if (mode === 'book') {
      el.when.textContent = fmtDay(dayKey(state.slot), { weekday: 'short', day: 'numeric', month: 'short' }).replace(',', '') + ', ' + fmtTime(state.slot);
      el.whensub.textContent = state.duration + ' minutes, ' + TZ_LABEL;
      el.change.textContent = 'Change';
      mountCheck();
    } else {
      el.when.textContent = 'We call you back';
      el.whensub.textContent = 'Usually within 5 minutes during business hours';
      el.change.textContent = 'Pick a time';
    }
    hideErr();
    el.status.hidden = true;
    setStep('details');
    inView(root);
    var first = el.form.querySelector('input[name="phone"]');
    if (first && matchMedia('(pointer: fine)').matches) first.focus({ preventScroll: true }); // phones: no keyboard until they tap a field
    track('booking_step', { step: mode === 'book' ? 'time' : 'callback' });
  }

  function syncLease() {
    var b = el.form.querySelector('input[name="buyer_type"]:checked');
    var show = !b || b.value === 'COMMERCIAL';
    el.lease.hidden = !show;
    el.lease.querySelectorAll('input').forEach(function (i) { i.disabled = !show; });
  }

  function hideErr() {
    el.err.hidden = true;
    el.form.querySelectorAll('[aria-invalid]').forEach(function (n) { n.removeAttribute('aria-invalid'); });
  }
  function showErr(msg, focusNode) {
    el.err.hidden = false;
    el.err.textContent = msg;
    if (focusNode) focusNode.focus();
  }

  function validate() {
    hideErr();
    var f = el.form, miss = [], firstBad = null;
    function bad(node, word) { node.setAttribute('aria-invalid', 'true'); miss.push(word); if (!firstBad) firstBad = node.matches('fieldset') ? node.querySelector('input') : node; }
    var phone = f.elements.phone, pc = f.elements.postcode, name = f.elements.fullname, email = f.elements.email;
    if ((phone.value.replace(/\D/g, '')).length < 8) bad(phone, 'mobile');
    if (!/^\d{4}$/.test(pc.value.trim())) bad(pc, 'site postcode');
    if (!name.value.trim()) bad(name, 'name');
    if (!email.checkValidity() || !email.value.trim()) bad(email, 'email');
    var buyer = f.querySelector('input[name="buyer_type"]:checked');
    if (!buyer) bad(f.querySelector('input[name="buyer_type"]').closest('fieldset'), 'commercial or home');
    var leaseMissing = buyer && buyer.value === 'COMMERCIAL' && !f.querySelector('input[name="lease"]:checked');
    if (leaseMissing) { el.lease.setAttribute('aria-invalid', 'true'); if (!firstBad) firstBad = el.lease.querySelector('input'); }
    if (!miss.length && !leaseMissing) return true;
    var words = miss.length > 1 ? miss.slice(0, -1).join(', ') + ' and ' + miss[miss.length - 1] : miss[0];
    var msg = miss.length ? 'Add your ' + words + (leaseMissing ? ', and choose where your lease is at.' : '.') : 'Choose where your lease is at.';
    if (miss.indexOf('site postcode') > -1) msg += ' The postcode is 4 digits.';
    showErr(msg, firstBad);
    return false;
  }

  function collect() {
    var f = el.form;
    function v(n) { var i = f.elements[n]; return i && i.value ? String(i.value).trim() : ''; }
    function picked(n) { var i = f.querySelector('input[name="' + n + '"]:checked:not(:disabled)'); return i ? i.value : ''; }
    var full = v('fullname').replace(/\s+/g, ' '), bits = full.split(' ');
    var d = {
      fullname: full, firstname: bits.shift() || '', lastname: bits.join(' '),
      email: v('email'), phone: v('phone'), postcode: v('postcode'),
      buyer_type: picked('buyer_type'), lease: picked('lease'),
      channel: state.mode === 'book' ? (picked('channel') || 'phone') : '',
      lead_id: leadId(), offer: OFFER
    };
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'fbclid'].forEach(function (k) { if (params.get(k)) d[k] = params.get(k); });
    return d;
  }

  /* what the rep sees on the invite ("Topic" / "What we'll cover"). A Teams customer sees it too, so it holds only their own
     answers; the page version goes to HubSpot instead. The booking system cuts it at 300 characters. */
  function topic(d) {
    return [d.buyer_type === 'HOME' ? 'Home gym' : 'Commercial gym, studio or facility',
      d.lease ? 'Lease: ' + d.lease : '', 'Site postcode: ' + d.postcode].filter(Boolean).join(' | ').slice(0, 300);
  }

  /* what sales sees in HubSpot */
  function summary(d, b, kind) {
    var label = root.getAttribute('data-lead-label-' + OFFER) || 'Call booking (book-a-call page)';
    var how = d.channel === 'teams' ? 'Microsoft Teams video call' : 'phone call';
    var lines = [label];
    if (kind === 'booked') lines.push('Call booked: ' + longWhen(b.start || state.slot) + ' ' + TZ_LABEL + ' (' + how + ', ' + (b.duration || state.duration) + ' minutes)' + (b.rep_name ? ', with ' + b.rep_name : ''));
    if (kind === 'callback') lines.push('Call-back requested (no time picked). Call them back, usually within 5 minutes during business hours.');
    if (kind === 'failed') lines.push('The booking system did not confirm the time. They wanted ' + longWhen(state.slot) + ' ' + TZ_LABEL + ' (' + how + ', ' + state.duration + ' minutes). Call them to lock it in.');
    lines.push('Commercial or home: ' + (d.buyer_type === 'HOME' ? 'Home gym' : 'Commercial gym, studio or facility'));
    if (d.lease) lines.push('Lease: ' + d.lease);
    lines.push('Site postcode: ' + d.postcode);
    lines.push('Page version seen: ' + OFFER_NAME[OFFER] + ' (offer=' + OFFER + ')');
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(function (k) { if (d[k]) lines.push(k + ': ' + d[k]); });
    lines.push('Lead ref: ' + d.lead_id);
    lines.push('Page: ' + location.pathname + location.search);
    return lines.join('\n');
  }

  function sendHubspot(d, b, kind) {
    if (!HS) return Promise.resolve('concept'); // concept file: nothing is sent
    var ids = HS.split('/');
    var fields = [
      { name: 'firstname', value: d.firstname }, { name: 'lastname', value: d.lastname },
      { name: 'email', value: d.email }, { name: 'phone', value: d.phone },
      { name: 'message', value: summary(d, b, kind) },
      { name: 'home_commercial', value: d.buyer_type === 'HOME' ? 'HOME' : 'COMMERCIAL' } // the visitor's own answer (COMMERCIAL is pre-selected on this page and can be changed)
    ];
    if (d.utm_source) fields.push({ name: 'utm_source', value: d.utm_source });
    var body = { fields: fields.filter(function (f) { return f.value !== ''; }), context: { pageUri: location.href, pageName: document.title } };
    var hutk = cookie('hubspotutk'); if (hutk) body.context.hutk = hutk;
    return fetch('https://api.hsforms.com/submissions/v3/integration/submit/' + ids[0] + '/' + ids[1], {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), keepalive: true
    }).then(function (r) { if (!r.ok) throw new Error('hubspot ' + r.status); return 'sent'; });
  }

  /* ---------- the bot check the booking system requires (Cloudflare Turnstile) ---------- */
  var check = { loading: null, widget: null, token: null, failed: false, interactive: false };
  function loadCheck() {
    if (check.loading) return check.loading;
    check.loading = new Promise(function (res, rej) {
      if (window.turnstile) return res(window.turnstile);
      var s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      s.async = true;
      s.onload = function () { var n = 0; (function wait() { if (window.turnstile) return res(window.turnstile); if (++n > 50) return rej(new Error('check')); setTimeout(wait, 100); })(); };
      s.onerror = function () { rej(new Error('check blocked')); };
      document.head.appendChild(s);
    });
    return check.loading;
  }
  function mountCheck() {
    if (!SITEKEY || check.widget !== null) return;
    loadCheck().then(function (t) {
      if (check.widget !== null) return;
      check.widget = t.render('#bk-ts', {
        sitekey: SITEKEY, appearance: 'interaction-only', size: 'flexible', // no 'action', same as Niall's own widget, so the backend sees identical tokens
        callback: function (tok) { check.token = tok; check.interactive = false; hideErr(); },
        'expired-callback': function () { check.token = null; },
        'error-callback': function () { check.token = null; },
        // Cloudflare wants a tick ("Verify you are human"): most visitors never see this
        'before-interactive-callback': function () { check.interactive = true; },
        'after-interactive-callback': function () { check.interactive = false; },
        'unsupported-callback': function () { check.failed = true; }
      });
    }).catch(function () { check.failed = true; });
  }
  function resetCheck() {
    check.token = null;
    try { if (window.turnstile && check.widget !== null) window.turnstile.reset(check.widget); } catch (e) {}
  }
  function getToken() {
    if (!API) return Promise.resolve('demo');
    if (!SITEKEY) return Promise.resolve('dev');
    mountCheck();
    return new Promise(function (res, rej) {
      var n = 0;
      (function wait() {
        if (check.token) return res(check.token);
        if (check.interactive) { var i = new Error('tick needed'); i.tick = true; return rej(i); }
        if (check.failed) { var e = new Error('check failed to load'); e.fallback = true; return rej(e); }
        if (++n > 120) { var t = new Error('check timeout'); t.fallback = true; return rej(t); } // no token after 12s and no tick asked: don't lose the lead
        setTimeout(wait, 100);
      })();
    });
  }

  /* ---------- send ---------- */
  function busy(on) {
    state.busy = on;
    el.go.disabled = on;
    if (on) el.go.setAttribute('aria-busy', 'true'); else el.go.removeAttribute('aria-busy');
  }

  function book(d) {
    busy(true);
    getToken().then(function (token) {
      var body = {
        start: state.slot, duration: state.duration, name: d.fullname, email: d.email, phone: d.phone, company: '', topic: topic(d),
        channel: d.channel === 'teams' ? 'teams' : 'phone', tz: TZ, turnstile_token: token, idempotency_key: idemKey(state.slot)
      };
      if (REP) body.rep = REP;
      if (!API) return demoBook(body);
      return fetch(API + '/book', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { status: r.status, data: j }; }); });
    }).then(function (res) {
      if (res.status === 200 && res.data && res.data.ok) {
        var b = res.data.booking || {};
        sendHubspot(d, b, 'booked').catch(function (e) { track('booking_error', { stage: 'hubspot', detail: String(e && e.message) }); });
        finish(d, b, 'booked');
        return;
      }
      busy(false);
      if (res.status === 409) { // someone took it first
        resetCheck();
        track('booking_error', { stage: 'book', status: 409 });
        var day = state.day || dayKey(state.slot);
        load(day, true).then(function () {
          if (!wide()) setStep(state.day ? 'time' : 'day');
          el.flash.hidden = false;
          el.flash.textContent = 'Sorry, someone just booked that time. Pick another one.';
          inView(root);
        });
        return;
      }
      if (res.status === 403) { resetCheck(); track('booking_error', { stage: 'check', status: 403 }); showErr('The security check didn’t pass. Please tap the button again.'); return; }
      if (res.status >= 400 && res.status < 500 && res.data && res.data.error) { resetCheck(); track('booking_error', { stage: 'book', status: res.status }); showErr(String(res.data.error)); return; }
      var e = new Error('book ' + res.status); e.fallback = true; throw e;
    }).catch(function (e) {
      if (e && e.tick) {
        busy(false);
        showErr('Tick “Verify you are human” above, then tap the button again.');
        var box = document.getElementById('bk-ts'); if (box) inViewCentre(box);
        return;
      }
      // the booking system is down or blocked: they still asked for a call, so the lead goes to HubSpot with the time they wanted
      track('booking_error', { stage: 'book', detail: String(e && e.message) });
      sendHubspot(d, null, 'failed').then(function () { finish(d, null, 'failed'); }).catch(function () {
        busy(false);
        showErr('That didn’t go through. Please try again, or call us on 1300 1947 48.');
      });
    });
  }

  function callback(d) {
    busy(true);
    sendHubspot(d, null, 'callback').then(function () { finish(d, null, 'callback'); }).catch(function () {
      busy(false);
      showErr('That didn’t send. Please try again, or call us on 1300 1947 48.');
    });
  }

  function finish(d, b, kind) {
    busy(false);
    var first = d.firstname ? d.firstname.charAt(0).toUpperCase() + d.firstname.slice(1) : 'there';
    var t = el.done.querySelector('.bk__donet');
    var when = el.done.querySelector('.bk__donewhen');
    var list = el.done.querySelector('.bk__next');
    var manage = el.done.querySelector('.bk__manage');
    var rep = b && b.rep_name ? b.rep_name.split(/\s+/)[0] : '';
    var teams = d.channel === 'teams';
    var steps = [];
    if (kind === 'booked') {
      t.innerHTML = 'You’re booked in, ' + esc(first) + '.';
      when.textContent = longWhen(b.start || state.slot) + ', ' + TZ_LABEL + '.';
      steps.push(teams
        ? '<b>Your Microsoft Teams invite is on its way</b> to ' + esc(d.email) + '.' + (b.teams_join_url ? ' <a href="' + esc(b.teams_join_url) + '" target="_blank" rel="noopener">Join the call</a>' : '')
        : '<b>' + esc(rep || 'A fit-out specialist') + ' calls you on ' + esc(d.phone) + '</b> at ' + esc(fmtTime(b.start || state.slot)) + ', for ' + (b.duration || state.duration) + ' minutes.');
    } else {
      t.innerHTML = 'Thanks, ' + esc(first) + '. We’ll call you.';
      when.textContent = kind === 'failed'
        ? 'We’ve got your details. A specialist will call ' + d.phone + ' to lock in ' + longWhen(state.slot) + '.'
        : 'We’ll call ' + d.phone + ', usually within 5 minutes during business hours.';
    }
    steps.push('<b>Have a floor plan?</b> Text it to ' + TEXT_LINE + ' or email <a href="mailto:sales@vervefitness.com.au">sales@vervefitness.com.au</a>. A phone photo of a sketch is enough.');
    steps.push(OFFER === 'design'
      ? '<b>Your free 3D design and itemised quote</b> come back inside a week of the call.'
      : '<b>Want it drawn?</b> Your free 3D design and itemised quote come back inside a week of the call.');
    list.innerHTML = steps.map(function (s) { return '<li>' + s + '</li>'; }).join('');
    if (b && b.manage_token) {
      manage.hidden = false;
      manage.innerHTML = 'Need to change it? <a href="https://www.vervefitness.com.au/pages/book-a-call?manage=' + encodeURIComponent(b.manage_token) + '">Cancel this booking</a> and pick a new time.';
    }
    setStep('done');
    inView(root);
    el.done.focus({ preventScroll: true });
    track('lead', { form: 'bk-form', kind: kind, booked: kind === 'booked', channel: d.channel || 'callback', buyer_type: d.buyer_type === 'HOME' ? 'home' : 'commercial', lease: d.lease || '', lead_id: d.lead_id, duration: kind === 'callback' ? 0 : (b && b.duration) || state.duration });
  }

  /* ---------- concept file only: demo times shaped like the real ones (weekdays, 7am to 3:30pm Brisbane) ---------- */
  function demoSlots(len) {
    var out = [], base = parts(new Date().toLocaleDateString('en-CA', { timeZone: 'Australia/Brisbane' }));
    for (var i = 0; i < 21; i++) {
      var day = new Date(Date.UTC(base.y, base.m, base.d + i));
      var dow = day.getUTCDay();
      if (dow === 0 || dow === 6) continue;
      for (var h = 7; h < 16; h += len === 15 ? 0.25 : 0.5) {
        if ((day.getUTCDate() * 3 + h * 2) % 7 === 0) continue; // a few taken times
        out.push(new Date(Date.UTC(day.getUTCFullYear(), day.getUTCMonth(), day.getUTCDate(), Math.floor(h) - 10, (h % 1) * 60)).toISOString());
      }
    }
    return new Promise(function (r) { setTimeout(function () { r({ duration: 30, slots: out }); }, 350); });
  }
  function demoBook(body) {
    return new Promise(function (r) { setTimeout(function () { r({ status: 200, data: { ok: true, booking: { start: body.start, duration: body.duration, channel: body.channel, rep_name: '', manage_token: '' } } }); }, 500); });
  }

  /* ---------- events ---------- */
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-len]') && !wide() && Date.now() - swappedAt < 400) { e.preventDefault(); return; } // the length tiles sit where the days were
    var t = e.target.closest('button');
    if (!t || !root.contains(t)) return;
    if (t.hasAttribute('data-day')) {
      state.day = t.getAttribute('data-day');
      swappedAt = Date.now();
      el.status.hidden = true;
      renderMonth(); renderTimes();
      setStep('time');
      if (!wide()) inView(root);
      var firstSlot = el.slots.querySelector('.bk__slot');
      if (firstSlot && !wide()) firstSlot.focus({ preventScroll: true });
      track('booking_step', { step: 'day' });
    } else if (t.hasAttribute('data-month')) {
      var dir = +t.getAttribute('data-month'), mi = monthIndex(state.month) + dir;
      state.month = { y: Math.floor(mi / 12), m: mi % 12 };
      renderMonth();
    } else if (t.hasAttribute('data-slot')) {
      if (!wide() && Date.now() - swappedAt < 400) return;
      state.slot = t.getAttribute('data-slot');
      openDetails('book');
    } else if (t.hasAttribute('data-callback')) {
      state.slot = null;
      openDetails('callback');
    } else if (t.hasAttribute('data-retry')) {
      load();
    } else if (t.getAttribute('data-to') === 'day') {
      setStep('day');
    } else if (t.getAttribute('data-to') === 'time') { // "Change" / "Pick a time" on the details step
      state.mode = 'book';
      root.setAttribute('data-mode', 'book');
      setStep(state.day && !wide() ? 'time' : 'day');
      if (!state.day && wide() && state.days.length) { state.day = state.days[0]; renderMonth(); renderTimes(); }
      inView(root);
    }
  });
  // 15 or 30 minutes: show the open times for that length and keep the visitor's day where it still has times
  if (lenBox) lenBox.addEventListener('change', function (e) {
    var len = +e.target.value;
    if (!len || len === state.duration) return;
    state.duration = len;
    track('booking_length', { duration: len });
    var step = root.getAttribute('data-step'), keep = state.day;
    el.slots.innerHTML = '<p class="bk__none">Loading times…</p>';
    fetchSlots(len).then(function (d) {
      if (state.duration !== len) return; // switched again while this was loading
      applySlots(d, keep, true);
      setStep(step === 'time' && !wide() ? 'time' : 'day');
    }).catch(function () {
      el.slots.innerHTML = '<p class="bk__none">We couldn’t load those times. Try again, or call 1300 1947 48.</p>';
    });
  });
  el.form.addEventListener('change', function (e) {
    if (e.target.name === 'buyer_type') { syncLease(); track('buyer_type_change', { to: e.target.value === 'HOME' ? 'home' : 'commercial' }); }
    var fs = e.target.closest('[aria-invalid]'); if (fs) fs.removeAttribute('aria-invalid');
    clearErrIfFixed();
  });
  el.form.addEventListener('input', function (e) { if (e.target.hasAttribute('aria-invalid')) e.target.removeAttribute('aria-invalid'); clearErrIfFixed(); });
  function clearErrIfFixed() { if (!el.err.hidden && !el.form.querySelector('[aria-invalid]')) el.err.hidden = true; } // everything it flagged is fixed: drop the red message
  el.form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (state.busy || !validate()) return;
    var d = collect();
    if (state.mode === 'callback') callback(d); else book(d);
  });

  // every "book a call time" button outside the card brings the visitor to it
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="tel:"]');
    if (a) track('call_click', { from: a.getAttribute('data-call') || '' });
    var j = e.target.closest && e.target.closest('[data-book-jump]');
    if (!j) return;
    e.preventDefault();
    var top = root.getBoundingClientRect().top + window.scrollY - 12;
    window.scrollTo({ top: Math.max(0, top), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    track('book_jump', { from: j.getAttribute('data-book-jump') });
  });

  // a resize across the two-pane width keeps the visitor's step sensible
  var wasWide = wide();
  addEventListener('resize', function () {
    var w = wide();
    if (w === wasWide) return;
    wasWide = w;
    var s = root.getAttribute('data-step');
    if (w && s === 'time') setStep('day');
    if (w && !state.day && state.days.length) { state.day = state.days[0]; renderMonth(); renderTimes(); }
  });

  syncLease();
  load();
})();

/* logo strip: mark it scrollable (for the edge fade) only when the logos don't all fit, and drop the fade at the end */
(function () {
  var row = document.querySelector('[data-logo-row]');
  if (!row) return;
  var check = function () {
    var scroll = row.scrollWidth > row.clientWidth + 2;
    row.classList.toggle('is-scroll', scroll);
    row.classList.toggle('at-end', scroll && row.scrollLeft + row.clientWidth >= row.scrollWidth - 4);
  };
  row.addEventListener('scroll', check, { passive: true });
  addEventListener('resize', check);
  addEventListener('load', check);
  check();
})();
